<template>
    <div v-if="isCookieToastVisible && !isLoading" class="cookie-toast-wrap">
        <div class="wrapper">
            <div class="cookie-toast">
                <button @click="setOnlyTech()" class="close"><img src="/Images/close.svg" width="18" height="18" class="image" alt="Close" /></button>
                <div class="description">
                    <div class="title"><img src="/Images/cookie.svg" class="icon" :alt="localizer.get('CookieToast.Common.CookiePolicy')" />{{ localizer.get("CookieToast.Common.CookiePolicy") }}</div>
                    <span v-html="localizer.get('CookieToast.Common.Description', routes.Terms_CookiePolicy)"></span>
                </div>
                <div class="links">
                    <div class="item action">
                        <button @click="setCookieToast()" class="button" data-border>{{ localizer.get("CookieToast.Common.AgreeAll") }}</button>
                    </div>
                    <div class="item tech">
                        <button @click="setOnlyTech()" class="button" data-border>{{ localizer.get("CookieToast.Common.OnlyTechnicians") }}</button>
                    </div>
                    <div class="item custom">
                        <button @click="setCustomize()" class="button" data-border>{{ localizer.get("CookieToast.Common.Customize") }}</button>
                    </div>
                </div>
                <div :class="['customize', !isCustomize ? 'hden' : '']">
                    <div class="title">{{ localizer.get("CookieToast.Common.CustomizeTitle") }}</div>
                    {{ localizer.get("CookieToast.Common.CustomizeDescription") }}
                    <div class="list-item">
                        <div class="item">
                            <div class="info" data-full>
                                <div class="type">{{ localizer.get("CookieToast.Common.Technicians") }}</div>
                                Google Analytics, Google.com
                            </div>
                        </div>
                        <div class="item">
                            <div class="info">
                                <div class="type">{{ localizer.get("CookieToast.Common.Profiling") }}</div>
                                Facebook (FB)
                            </div>
                            <div class="action">
                                <button v-if="isActivateProfiling" @click="setProfiling()" class="button" data-border>{{ localizer.get("CookieToast.Common.Deactivate") }}</button>
                                <button v-else @click="setProfiling()" class="button" data-border>{{ localizer.get("CookieToast.Common.Activate") }}</button>
                            </div>
                        </div>
                    </div>
                    <div class="confirm">
                        <button @click="setCustomCookie()" class="button" data-accent>{{ localizer.get("CookieToast.Common.SavePreferences") }}</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script setup lang="ts">
import { ref, computed, watch, onBeforeMount } from "vue";
import { useStore } from "vuex";
import CookieHelper from "@Scripts/Infrastructure/CookieHelper";
import Localizer from "@Scripts/Common/Localizer";

const store = useStore();

const localizer = Localizer;
const routes = (window as any).App.routes;

const isLoading = ref(true);
const isCustomize = ref(false);
const isActivateStatistics = ref(false);
const isActivateProfiling = ref(false);
const cookiePolicyUrl = ref<string>(null);
const customizeCookieValues = ref<string[]>(["tech"]);

const isCookieToastVisible = computed(() => {
    return store.getters["cookieToastStore/isCookieToastVisible"];
});

watch(isCookieToastVisible, async (newValue: boolean) => {
    isLoading.value = true;

    store.commit("cookieToastStore/setCookieToastVisible", newValue);

    isLoading.value = false;
});

onBeforeMount(() => {
    if (!CookieHelper.isCookiePolicy()) {
        store.commit("cookieToastStore/setCookieToastVisible", true);
    }
});

function setCustomize() {
    isCustomize.value = !isCustomize.value;
}

function setStatistics() {
    isActivateStatistics.value = !isActivateStatistics.value;

    if (isActivateStatistics.value) {
        customizeCookieValues.value.push("stat");
    } else {
        let index = customizeCookieValues.value.indexOf("stat");
        if (index !== -1) {
            customizeCookieValues.value.splice(index, 1);
        }
    }
}

function setProfiling() {
    isActivateProfiling.value = !isActivateProfiling.value;

    if (isActivateProfiling.value) {
        customizeCookieValues.value.push("profile");
    } else {
        let index = customizeCookieValues.value.indexOf("profile");
        if (index !== -1) {
            customizeCookieValues.value.splice(index, 1);
        }
    }
}

function setCookieToast() {
    CookieHelper.setCookiePolicyAll();
    store.commit("cookieToastStore/setCookieToastVisible", false);
    window.location.reload();
}

function setOnlyTech() {
    CookieHelper.removeCookiePolicyAll();
    store.commit("cookieToastStore/setCookieToastVisible", false);
    window.location.reload();
}

function setCustomCookie() {
    CookieHelper.setCookie("ckp", customizeCookieValues.value.join("|"), 365);
    store.commit("cookieToastStore/setCookieToastVisible", false);
    window.location.reload();
}
</script>
